import { InvokeFunctionExpr } from '@angular/compiler';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DealDispositionsService } from 'src/app/deals/deal-dispositions/deal-dispositions.service';
import DateClass from 'src/app/interfaces/date-class';
import DateType from 'src/app/interfaces/date-type';
import Disposition from 'src/app/interfaces/disposition';
import DispositionDate from 'src/app/interfaces/disposition-date';
import DispositionPipelineDate from 'src/app/interfaces/disposition-pipeline-date';
import Status from 'src/app/interfaces/status';
import Either from 'src/app/types/either';

export type DateOutput = Either<
  Either<DispositionPipelineDate, DispositionDate>,
  { date: string }
>;

@Component({
    selector: 'disposition-date',
    templateUrl: './disposition-date.component.html',
    styleUrls: ['./disposition-date.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DispositionDateComponent {
  @Input() name: string;
  @Input() label: string;
  @Input() dateTypeName?: string;
  @Input() pipelineMilestoneName?: string;
  @Input() disposition: Disposition;
  @Input() statuses: Status[] | null;
  @Input() dateTypes: DateType[] | null;
  @Input() dateClass: DateClass | null;
  @Input() disabled: boolean | null = null;

  @Output() dateChanged: EventEmitter<DateOutput> =
    new EventEmitter<DateOutput>();

  public dateObject: DateOutput;
  public relatedId: string;
  constructor(public dispositionsService: DealDispositionsService) {}

  ngOnInit() {
    if (this.pipelineMilestoneName) {
      if (this.statuses && this.statuses.length) {
        let status = this.statuses.find(
          (value) => value.name === this.pipelineMilestoneName
        );
        if (
          status &&
          status.statusSequenceDetails &&
          status.statusSequenceDetails.length &&
          status.statusSequenceDetails[0].milestoneStatus
        ) {
          this.relatedId =
            status.statusSequenceDetails[0].milestoneStatus.pipeline_milestone_id;
          this.dateObject = this.disposition.dispositionPipelineDates?.find(
            (value) => value.pipeline_milestone_id === this.relatedId
          ) ?? {
            disposition_id: this.disposition.id,
            pipeline_milestone_id: this.relatedId,
            date: '',
          };
        }
      }
    } else if (this.dateTypeName) {
      if (this.dateTypes && this.dateTypes.length && this.dateClass) {
        let dateType = this.dateTypes.find(
          (value) => value.name === this.dateTypeName
        );
        if (dateType) {
          this.relatedId = dateType.id;
          this.dateObject = this.disposition.dispositionDates?.find(
            (value) => value.date_type_id === this.relatedId
          ) ?? {
            date_type_id: this.relatedId,
            date_class_id: this.dateClass.id,
            date: '',
            disposition_id: this.disposition.id,
          };
        }
      }
    } else {
      //this is just to keep the console from blowing up if we can't resolve this to a real type.
      this.dateObject = { date: '' };
    }
  }
  updateDate($event: Event) {
    let target = $event.target as HTMLInputElement;
    this.dateObject.date = target.value;
    this.dateChanged.emit(this.dateObject);
  }
}
